<template>
  <div class="main">
    <el-dialog
      :close-on-click-modal="false"
      title="机构点"
      :visible.sync="openData.openState"
      width="700px"
      @close="dialogClose"
    >
      <div class="content">
        <div class="box">
          <el-table
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; margin: 15px 0"
            border
            ref="multipleTable"
            height="250"
          >
            <el-table-column label="选择" align="center" width="65">
              <template slot-scope="scope">
                <el-radio v-model="tableRadio" :label="scope.row"
                  ><i></i
                ></el-radio>
              </template>
            </el-table-column>
            <el-table-column label="服务编码" align="center" prop="statNum">
            </el-table-column>

            <el-table-column label="服务名称" align="center" prop="statName">
            </el-table-column>
            <el-table-column label="机构电话" align="center" prop="phone">
            </el-table-column>
          </el-table>
          <el-pagination
            align="center"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            :current-page.sync="pageNo"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            @size-change="handletableDataSize"
            @current-change="handleTableDataChange"
          ></el-pagination>
        </div>
      </div>
      <div class="footer">
        <el-button type="primary" @click="save">确 定</el-button>
        <el-button @click="dialogClose">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["openData"],
  data() {
    return {
      tableRadio: {},
      saveLoading: false,
      searchLoading: false,
      pageSize: 10,
      pageNo: 1,
      total: 0,
      chooseIds: [],
      tableData: [],
      name: "",
      phone: "",
      isSearchContent: true,
    }
  },
  created() {
    this.getList()
    this.chooseIds = []
  },

  methods: {
    // 搜搜
    searchList() {
      this.getList()
    },
    // 人员选择
    handleSelectionChange(rows) {
      if (rows) {
        rows.forEach((row, index) => {
          this.chooseIds.push(row.id)
        })
      }
    },
    // 获取表格数据
    getList() {
      let params = {
        name: this.name,
        phone: this.phone,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      this.$http
        .request({
          url: "/ypt/admin/serviceStation/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              this.total = 0
              return
            }
            this.tableData = []
            this.tableData = res.content.list
            this.total = res.content.count
          }
        })
    },
    // 页面大小
    handletableDataSize(val) {
      this.pageSize = val
      this.getList()
    },
    // 当前页
    handleTableDataChange(val) {
      this.pageNo = val
      this.getList()
    },
    // 保存信息
    save() {
      this.$emit("canclePerson", this.tableRadio)
      this.openData.openState = false
      // if (this.chooseIds.length > 0) {
      //     this.$emit("canclePerson", true)
      // } else {
      //     this.$message.warning("请先选择人员")
      // }
    },
    // 关闭人员信息
    dialogClose() {
      this.openData.openState = false
      this.$emit("canclePerson", false)
    },
  },
}
</script>
<style lang="less" scoped>
.content {
  border-top: 1px solid #eee;
}
.footer {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 15px;
}
/deep/ .search_wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  .search_head {
    background: #e6e6e6;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .search_content {
    padding: 42px 20px 20px 20px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .search_inline {
    width: 100%;
  }
  .arrowDown1 {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
  }
  .el-icon-arrow-up {
    &::before {
      color: #000;
      font-size: 18px;
    }
  }
}
.box {
  margin: 25px 0;
}
</style>
